import { Link } from 'react-router-dom';

export function Brand({ to = '/' }: { to?: string }) {
  return (
    <Link className="brand" to={to}>
      <img className="brand-logo" src="/logo.png" alt="Marketing Strategies" width={40} height={40} />
      <span className="brand-copy">
        <strong>Marketing Strategies</strong>
      </span>
    </Link>
  );
}
